module.exports = __webpack_public_path__ + "img/digital-footprint.ade7569f.svg";